import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { generatePath } from 'react-router'
import { useLocation } from 'react-router-dom'
import * as Sentry from '@sentry/browser'
import { selectAppLocale } from 'modules/App/store/selectors'

const pickDefinedPathParams = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value != null && value !== ''),
  )

const useGeneratePathI18n = () => {
  const i18n = useSelector(selectAppLocale)
  const { pathname } = useLocation()

  return useCallback(
    (route = '', params = {}) => {
      const { i18n: paramI18n, ...pathParams } = params
      const locale =
        (typeof paramI18n === 'string' && paramI18n) ||
        i18n ||
        pathname.split('/').filter(Boolean)[0] ||
        'ru'
      const resolvedParams = pickDefinedPathParams(pathParams)

      try {
        return generatePath(route, { i18n: locale, ...resolvedParams })
      } catch (err) {
        Sentry.captureException(
          'path generation error! params:' + JSON.stringify(params) + ', route:' + route,
        )
        throw err
      }
    },
    [i18n, pathname],
  )
}

export default useGeneratePathI18n
